import { Lightning, Utils } from '@lightningjs/sdk'

export default class Loader extends Lightning.Component {
  static _template() {
    return {
      Spinner: {
        w: 80,
        h: 80,
        x: 960,
        y: 640,
        mount: 0.5,
        rotation: true,
        src: Utils.asset('images/loaderSpinner.png'),
      },
    }
  }

  _init() {
    this._spinAnimation = this.animation({
      duration: 1,
      repeat: -1,
      stopMethod: 'finish',
      actions: [{ t: 'Spinner', p: 'rotation', v: { sm: 0, 0: { v: Math.PI * 2 }, 1: { v: 0 } } }],
    })
  }

  _active() {
    this._spinAnimation.start()
  }

  _inactive() {
    this._spinAnimation.stop()
  }

  start() {
    this.patch({
      smooth: { alpha: 1 },
    })
  }

  stop() {
    this.patch({
      smooth: { alpha: 0 },
    })
  }
}
